<template>
  <div>
    <form-filtered-select
      :selected-key="selectedCurrency ? selectedCurrency.value : null"
      :options="currencyOptions"
      :invalid="invalid"
      placeholder="Currency"
      @updateDropdownValue="onUpdateValue"
      @close="$emit('close')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedCurrency: null
    }
  },
  computed: {
    ...mapGetters('currency', ['currencyOptions'])
  },
  watch: {
    value: function () {
      if (this.selectedCurrency && this.value.value !== this.selectedCurrency.value) {
        this.selectedCurrency = this.value
      }
    }
  },
  mounted () {
    this.selectedCurrency = this.value
    this.$watch('selectedCurrency', function () {
      this.$emit('input', this.selectedCurrency)
    })
  },
  methods: {
    onUpdateValue (value) {
      this.selectedCurrency = value
    }
  }
}
</script>

<style lang="scss">
.multiselect {
  &__content-wrapper {
    z-index: 3000 !important;
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
